// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KT2pr","content":"styles_content__1ZiXg"};